import React from 'react';
import { Section } from 'common/components/items-menu/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
export function OverflowControls(_ref: {
  items: Section[];
}) {
  let {
    items
  }: {
    items: Section[];
  } = _ref;
  return <SelectReact neverShowCaret iconOnly experimentalPositioning theme={SelectTheme.Tertiary} sections={items} menuWidth={-1} // adjusts the menu width to hug content
  menuHeight={-1} icon={{
    leftIcon: "ellipsis"
  }} data-sentry-element="SelectReact" data-sentry-component="OverflowControls" data-sentry-source-file="controls.tsx" />;
}